import {OrderProduct} from "../OrderProduct/OrderProduct";
import {ContentTypes, Product} from "../Product/Product";

export type Order = {
    id: number;
    tax: number;
    shippingCost: number;
    totalAmount: number;
    refundedAmount?: number | null;
    fee?: number | null;
    sendCount: number;
    printPressed: number;
    /** Count of card payment details summary prints from the Stripe Payment Details modal (used for Card paid → Paid). */
    cardPaymentDetailsPrintCount?: number;
    shippingStatus: number;
    paymentStatus: OrderTypes;
    shippingComment: string | null;
    paymentComment: string | null;
    createdAt: number;
    poNumber: string | null;
    tbd: boolean;
    namePo: string | null;
    confirmNumber: string | null;
    products: Array<OrderProduct>;
    billingAddressId: number;
    shippingAddressId: number;
    user: OrderUser | null;
    dealership: OrderDealership | null;
    paymentType: PaymentTypes | null;
    isDeleted: boolean;
    stripeTransactionId: string | null;
};

export type PaperOrderStatus = {
    comment: string | null;
    showComment: boolean;
    status: string;
    statusDate: string;
    username: string;
};

export type PaperOrderDetails = {
    address1: string;
    address2: string;
    businessName: string;
    city: string;
    confirmationNumber: string;
    contactName: string;
    dealerLicenseNumber: string;
    emailAddress: string;
    orderDate: string;
    paperVendorNumber: string;
    phoneNumber: string;
    quantity: number;
    state: string;
    status: string;
    statusHistory: {
        paperOrderStatuses: PaperOrderStatus[];
    };
    zip: string;
};

export type InvoiceCompactDTO = {
    id: number | string;
    printPressed: number;
    sendCount: number;
    /** Статус оплаты (OrderTypes / API id), для условий отправки инвойса. */
    paymentStatus?: number;
    cardPaymentDetailsPrintCount?: number;
    dealershipName: string;
    dealershipEmail: string;
};

export type OrderUser = {
    id: number;
    name: string;
    email: string;
    isAdmin: boolean;
};

export type OrderDealership = {
    id: number;
    companyId: number;
    name: string;
    email: string;
    localStatus: boolean;
};

export type OrderProductSimple = {
    id: number;
    createdAt: number;
    quantity: number;
};

export enum OrderTypes {
    IN = 0,
    PENDING = 1,
    PAID = 2,
    FREE = 3,
    TBD = 4,
    CARD_PAID = 5,
    REFUND = 6
};

export enum PaymentTypes {
    CARD = 'CARD',
    INVOICE = 'INVOICE'
}

export type SortDirection = 'NO' | 'ASC' | 'DESC';

export interface ReqOrderConfig {
    params: {
        page: number;
        size: number;
        state?: OrderTypes;
        reminder?: boolean;
    };
    data: {
        [key: string]: any
    };
}

export interface CheckBasketResponseDTO {
    items: Product[]; // Ссылка на интерфейс ProductDTO
    dealershipId: number;
    outOffDateProduct: Record<number, CompareObject[]>; // HashMap заменяется на Record
    outOfDateDiscount: Record<number, CompareDiscountObject[]>; // HashMap заменяется на Record
}

export interface CompareObject {
    field: string;
    current: string;
    outOffDate: string;
}

export interface CompareDiscountObject {
    discountType: ContentTypes;
    current: string;
    outOffDate: string;
}